/** A key the page may use as a shortcut: not typed into a field, and without Ctrl, Alt or Cmd. */
export function isShortcutKey(e: KeyboardEvent): boolean {
  const target = e.target as HTMLElement | null;
  if (target && (['INPUT', 'SELECT', 'TEXTAREA'].includes(target.tagName) || target.isContentEditable)) return false;
  return !(e.ctrlKey || e.metaKey || e.altKey);
}

/**
 * Space is play / stop on the practice and rehearsal pages. If a button has the focus (for
 * example Play, after a click), take it away first: otherwise the browser would also press that
 * button when the key comes up, and draw its focus ring.
 */
export function releaseButtonFocus(): void {
  const active = document.activeElement;
  if (active instanceof HTMLButtonElement) active.blur();
}
